export const DEFAULT_APP_CONTEXT_SIZE_LIMIT_BYTES = 8 * 1024;

export function enforceSizeLimit<T extends object>(
  obj: T,
  limitBytes = DEFAULT_APP_CONTEXT_SIZE_LIMIT_BYTES,
): T {
  const encoder = new TextEncoder();
  const raw = JSON.stringify(obj);
  if (encoder.encode(raw).byteLength <= limitBytes) return obj;
  const truncated: Record<string, unknown> = structuredClone(obj) as Record<string, unknown>;
  for (const key of Object.keys(truncated)) {
    if (key === 'route') continue;
    truncated[key] = { __truncated: true };
    if (encoder.encode(JSON.stringify(truncated)).byteLength <= limitBytes) break;
  }
  return truncated as T;
}
